import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function Cookies() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="info-page" id="main-content">
      <div className="info-shell info-shell--narrow">
        <nav className="info-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link><span aria-hidden="true">/</span><span aria-current="page">Cookie policy</span>
        </nav>
        <header className="info-page__header info-page__hero">
          <p className="info-page__eyebrow">Browser storage</p>
          <h1>Cookie policy.</h1>
          <p className="info-page__lead">This page explains how {siteConfig.legalName}, trading as {siteConfig.brandName}, uses cookies and similar browser storage.</p>
          <p className="info-page__updated">Last updated · September 2026</p>
        </header>

        <article className="info-page__article">
          <section><p className="info-page__eyebrow">01</p><h2>What these tools are</h2><p>Cookies are small data files stored by a browser. Similar technologies include local storage and session storage. They can remember an action or preference between pages or visits.</p></section>
          <section><p className="info-page__eyebrow">02</p><h2>Strictly necessary storage</h2><p>The storefront may use necessary storage to keep the shopping bag and wishlist available, maintain security and support core page functions. These features cannot always be disabled without affecting the service.</p></section>
          <section><p className="info-page__eyebrow">03</p><h2>Optional measurement and marketing</h2><p>If analytics, personalisation or advertising tools are added, they should be activated only in line with the choices presented to you and applicable requirements. We do not describe an optional provider as active unless it is actually used.</p></section>
          <section><p className="info-page__eyebrow">04</p><h2>Your choices</h2><p>You can clear or block stored data through your browser settings. Blocking necessary storage may prevent the bag, wishlist or checkout flow from working as expected. Where a cookie preference control is provided, you can revisit it to change optional choices.</p></section>
          <section><p className="info-page__eyebrow">05</p><h2>Changes to this policy</h2><p>We may update this page if the storefront or the tools it uses change. The date above identifies the current version.</p></section>
        </article>

        <aside className="info-page__contact-card">
          <p className="info-page__eyebrow">Questions</p><h2>Ask about browser storage.</h2>
          <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or read our <Link to="/privacy" onClick={toTop}>privacy policy</Link>.</p>
        </aside>
      </div>
    </main>
  );
}

export default Cookies;
